module.exports = {
      id: "minus-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "images/sprites/ui.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }